import { useMemo } from 'react';

import findGreaterClosestNumber from '@commons/utils/array/findGreaterClosestNumber';
import { IMAGE_SIZE, IMAGE_SIZES_BY_SCREEN } from '@services/images/constants';
import useScreenWidthBySize from '../useScreenWidthBySize';

function useScreenWidthImage({ width, size = IMAGE_SIZE.FULL } = {}) {
  const widthBySize = useScreenWidthBySize(size);
  const availableWidths = IMAGE_SIZES_BY_SCREEN[size];

  const value = useMemo(
    () =>
      width ||
      (widthBySize && findGreaterClosestNumber(availableWidths, widthBySize)) ||
      null,
    [availableWidths, width, widthBySize],
  );

  return value;
}

export default useScreenWidthImage;
